const _cache = {}

const loadScript = uri => {
  return (
    _cache[uri] ||
    (_cache[uri] = new Promise((resolve, reject) => {
      let $el

      if (uri.endsWith('.js')) {
        $el = document.createElement('script')
        $el.src = uri
        $el.onload = resolve
        $el.onerror = reject
        $el.onabort = reject
      } else if (uri.endsWith('.css')) {
        $el = document.createElement('link')
        $el.href = uri
        $el.rel = 'stylesheet'
        $el.onload = resolve
        $el.onerror = reject
        $el.onabort = reject
      }

      ;(document.head || document.getElementsByTagName('head')[0]).append($el)
    }))
  )
}

export async function loadHighlight() {
  await loadScript(
    'https://cdn.bootcdn.net/ajax/libs/highlight.js/11.5.0/highlight.min.js'
  )

  await Promise.all([
    loadScript(
      'https://cdn.bootcdn.net/ajax/libs/highlight.js/11.5.0/languages/json.min.js'
    ),
    loadScript(
      'https://cdn.bootcdn.net/ajax/libs/highlight.js/11.5.0/styles/github.min.css'
    ),
  ])
}

export default {
  components: {
    highlight: () => {
      const component = {
        props: {
          value: String,
        },

        computed: {
          jsonContent() {
            if (this.value) {
              try {
                return JSON.stringify(JSON.parse(this.value), null, 2)
              } catch (e) {}
            }
            return this.value || ''
          },
        },

        render(h) {
          //   return h('pre', [], h('code', { domProps: { innerText: this.jsonContent }, ref: 'code' }))
          return h('pre', {}, [
            h('code', {
              domProps: {
                innerHTML: hljs.highlight(this.jsonContent, {
                  language: 'json',
                  ignoreIllegals: false,
                }).value,
              },
            }),
          ])
        },
      }

      return loadHighlight().then(() => component)
    },
  },
}
